var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1386_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7537 1.00644C11.4033 0.651725 10.9111 0.429932 10.3754 0.429932C9.8392 0.429932 9.34743 0.651725 8.99666 1.00644C8.64505 1.3603 8.42542 1.85741 8.42586 2.39851C8.42542 2.9405 8.64505 3.43675 8.99666 3.79058C9.15175 3.94767 9.33589 4.07711 9.53755 4.17463V9.75374C9.53711 10.587 9.21541 11.3715 8.63135 11.9627C8.04644 12.5521 7.26927 12.8775 6.44429 12.8775C5.61883 12.8775 4.84211 12.5521 4.25722 11.9627C3.67319 11.3715 3.35146 10.587 3.35102 9.75374C3.35146 9.28555 3.45441 8.83417 3.64882 8.41992C3.91715 8.60633 4.23672 8.82122 4.35591 8.87129C4.46914 8.91962 4.75496 8.86914 4.646 8.36728C4.50072 7.70016 4.62975 6.88285 4.87629 5.87742C4.9596 5.53826 4.85963 5.44331 4.68999 5.48042C3.81499 5.58098 2.85752 6.49621 2.69647 6.77283L2.61914 6.87683C2.00134 7.71311 1.67534 8.70777 1.67578 9.75377C1.67534 11.041 2.17139 12.2505 3.07204 13.1593C3.97181 14.0689 5.16895 14.5699 6.44429 14.5699H6.44557C7.71963 14.5699 8.91676 14.0689 9.81654 13.1593C10.7176 12.2505 11.2132 11.041 11.2128 9.75374V4.1738C11.4149 4.07714 11.5986 3.94767 11.7537 3.79061C12.1053 3.43675 12.3249 2.94053 12.3245 2.39854C12.3249 1.85741 12.1053 1.3603 11.7537 1.00644ZM10.7514 2.77825C10.6527 2.87665 10.5245 2.93534 10.3754 2.93619C10.2263 2.93534 10.0977 2.87665 9.99941 2.77825C9.90199 2.67899 9.84388 2.54955 9.84347 2.39851C9.84391 2.24833 9.90201 2.11845 9.99941 2.01878C10.0977 1.92082 10.2263 1.86257 10.3754 1.86169C10.5245 1.86255 10.6527 1.92082 10.7514 2.01878C10.8484 2.11845 10.9065 2.24836 10.9069 2.39851C10.9064 2.54955 10.8483 2.67902 10.7514 2.77825Z",
    fill: "#254E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1386_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.14,
    fill: "white",
    transform: "translate(0 0.429932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHook);
export default __webpack_public_path__ + "static/media/hook.6ceefe5d03402910733e9b3c6468c72b.svg";
export { ForwardRef as ReactComponent };